exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".past-text-color[data-v-6df27cb2]{color:#767676}.inative-text-color[data-v-6df27cb2]{color:#928c99}.score-info-text[data-v-6df27cb2]{font-size:14px;@media screen and (min-width:768px){font-size:21px}}.score-sub-text[data-v-6df27cb2]{font-size:10px;@media screen and (min-width:768px){font-size:15px}}p[data-v-6df27cb2]{margin:0}", ""]);

// exports
